import { createSelector } from 'reselect'

export const getCartInitiallyFetched = createSelector(
  (state) => state && state.cart && state.cart.initiallyFetched,
  initiallyFetched => initiallyFetched
)
